import { Input as InputPrimitive } from "@base-ui/react/input";
import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "./cn";

export const inputVariants = cva(
  "w-full rounded-md border border-[var(--border)] bg-[var(--panel)] text-[var(--text)] text-xs placeholder:text-[var(--muted-2)] outline-none transition-colors focus-visible:border-[var(--border-strong)] focus-visible:ring-2 focus-visible:ring-[var(--ring)] disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      size: {
        default: "h-8 px-2.5 leading-8",
        compact: "h-7 px-2 text-[11px] leading-7",
        xs: "h-6 px-1.5 text-[10px] leading-6",
        lg: "h-9 px-3 text-sm leading-9",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

export type InputProps = Omit<ComponentPropsWithoutRef<"input">, "size"> &
  VariantProps<typeof inputVariants> & {
    readonly onValueChange?: (value: string) => void;
  };

export function Input({ className, size, onValueChange, onChange, ...props }: InputProps) {
  return (
    <InputPrimitive
      className={cn(inputVariants({ size }), className)}
      onChange={(event) => {
        onChange?.(event);
        onValueChange?.(event.currentTarget.value);
      }}
      data-slot="input"
      {...props}
    />
  );
}
